import React from 'react'
import RoomXS from './rooms/XS'
import RoomS from './rooms/S'
import RoomM from './rooms/M'
import RoomL from './rooms/L'
import RoomXL from './rooms/XL'
import RoomXXL from './rooms/XXL'

class Room extends React.Component {
  constructor(props) {
    super(props)
    let calculatedWidth = (window.innerWidth||document.documentElement.clientWidth||document.getElementsByTagName('body')[0].clientWidth) / 1
    // let calculatedHeight = window.innerHeight||document.documentElement.clientHeight||document.getElementsByTagName('body')[0].clientHeight
    this.state = {
      width: calculatedWidth > 1000 ? 1000 : calculatedWidth,
      ratio: (calculatedWidth > 1000 ? 1000 : calculatedWidth) / parseFloat(props.width),
      currentScenario: props.currentScenario
    }
  }
  componentDidUpdate() {
    if (typeof this.props.currentScenario !== 'undefined' && typeof this.state.currentScenario !== 'undefined' && this.props.currentScenario.id !== this.state.currentScenario.id) {
      this.setState({
        currentScenario: this.props.currentScenario
      })
    }
  }
  render() {
    return (
        <div>
        { 
          this.state.currentScenario.id === 1 ? 
            <div style={{ position: 'relative', margin: 'auto auto 50px', maxWidth: this.state.width, height: this.state.height }}>
              <RoomXS width={ this.state.width } />
            </div>
          : null 
        }
        { 
          this.state.currentScenario.id === 2 ? 
            <div style={{ position: 'relative', margin: 'auto auto 50px', maxWidth: this.state.width, height: this.state.height }}>
              <RoomS width={ this.state.width } />
            </div>
          : null 
        }
        { 
          this.state.currentScenario.id === 3 ? 
            <div style={{ position: 'relative', margin: 'auto auto 50px', maxWidth: this.state.width, height: this.state.height }}>
              <RoomM width={ this.state.width } />
            </div>
          : null 
        }
        { 
          this.state.currentScenario.id === 4 ? 
            <div style={{ position: 'relative', margin: 'auto auto 50px', maxWidth: this.state.width, height: this.state.height }}>
              <RoomL width={ this.state.width } />
            </div>
          : null 
        }
        { 
          this.state.currentScenario.id === 5 ? 
            <div style={{ position: 'relative', margin: 'auto auto 50px', maxWidth: this.state.width, height: this.state.height }}>
              <RoomXL width={ this.state.width } />
            </div>
          : null 
        }
        { 
          this.state.currentScenario.id === 6 ? 
            <div style={{ position: 'relative', margin: 'auto auto 50px', maxWidth: this.state.width, height: this.state.height }}>
              <RoomXXL width={ this.state.width } />
            </div>
          : null 
        }
      </div>
    )
  }
}

export default Room


// WEBPACK FOOTER //
// ./src/components/room/room.js